import { Button as e } from "../Button/Button.js";
import { ButtonIcon as t } from "../Button/ButtonIcon.js";
import n from "./Calendar.module.js";
import { useMemo as r, useState as i } from "react";
import { Fragment as a, jsxDEV as o } from "react/jsx-dev-runtime";
import { CaretLeftIcon as s, CaretRightIcon as c } from "@phosphor-icons/react";
//#region lib/components/DatePicker/MonthCalendar.tsx
var l = "/opt/render/project/src/shared-ui/lib/components/DatePicker/MonthCalendar.tsx", u = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];
function d({ month: d, onMonthChange: f, onSelectMonth: p, selectedMonth: m }) {
	let [h, g] = i(() => (d ?? /* @__PURE__ */ new Date()).getFullYear()), _ = d?.getFullYear() ?? h, v = r(() => {
		let e = [];
		for (let t = 0; t < u.length; t += 3) e.push(u.slice(t, t + 3));
		return e;
	}, []), y = (e) => {
		let t = _ + e;
		g(t);
		let n = new Date(t, d?.getMonth() ?? 0, 1);
		f?.(n);
	};
	return /* @__PURE__ */ o(a, { children: [/* @__PURE__ */ o("div", {
		className: n.monthHeader,
		children: [
			/* @__PURE__ */ o(t, {
				onClick: () => {
					y(-1);
				},
				"aria-label": "Previous year",
				icon: /* @__PURE__ */ o(s, { size: 24 }, void 0, !1, {
					fileName: l,
					lineNumber: 43,
					columnNumber: 27
				}, this),
				shape: "pill",
				color: "neutral"
			}, void 0, !1, {
				fileName: l,
				lineNumber: 38,
				columnNumber: 17
			}, this),
			/* @__PURE__ */ o("div", {
				className: n.monthHeaderLabel,
				children: _
			}, void 0, !1, {
				fileName: l,
				lineNumber: 47,
				columnNumber: 17
			}, this),
			/* @__PURE__ */ o(t, {
				onClick: () => {
					y(1);
				},
				"aria-label": "Next year",
				icon: /* @__PURE__ */ o(c, { size: 24 }, void 0, !1, {
					fileName: l,
					lineNumber: 53,
					columnNumber: 27
				}, this),
				shape: "pill",
				color: "neutral"
			}, void 0, !1, {
				fileName: l,
				lineNumber: 48,
				columnNumber: 17
			}, this)
		]
	}, void 0, !0, {
		fileName: l,
		lineNumber: 37,
		columnNumber: 13
	}, this), /* @__PURE__ */ o("div", {
		className: n.monthGrid,
		children: v.map((t) => /* @__PURE__ */ o("div", {
			className: n.monthRow,
			children: t.map((t) => {
				let r = u.indexOf(t), i = m ? m.getFullYear() === _ && m.getMonth() === r : !1;
				return /* @__PURE__ */ o(e, {
					className: n.monthButton,
					color: "neutral",
					size: "md",
					label: t,
					onClick: () => {
						p(r, _);
					},
					noBorder: !i
				}, t, !1, {
					fileName: l,
					lineNumber: 67,
					columnNumber: 33
				}, this);
			})
		}, t.join("-"), !1, {
			fileName: l,
			lineNumber: 60,
			columnNumber: 21
		}, this))
	}, void 0, !1, {
		fileName: l,
		lineNumber: 58,
		columnNumber: 13
	}, this)] }, void 0, !0, {
		fileName: l,
		lineNumber: 36,
		columnNumber: 9
	}, this);
}
//#endregion
export { d as MonthCalendar };
